// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export enum ClusterEngineRoles {
  master = 1,
  engine = 2
}

export const CLUSTER_ENGINES_ROLES_LABELS ={
  [ClusterEngineRoles.master]: 'Master',
  [ClusterEngineRoles.engine]: 'Engine' 
};

export const CLUSTER_FIELDS = {
  clusterName: 'clusterName',
  numberOfEngines: 'numberOfEngines',
  totalPassMarkScore: 'totalPassMarkScore',
  totalRAM: 'totalRAM',
  avgCPU: 'avgCPU',
  avgGPU:'avgGPU',
  lastUpdated: 'lastUpdated'
};

export const CLUSTER_ENGINE_FIELDS = {
  role: 'role',
  engineName: 'engineName',
  passMarkScore: 'passMarkScore',
  currentTaskId: 'currentTaskId',
  numberOfPendingTasks: 'numberOfPendingTasks',
  processorName: 'processorName',
  numberOfProcessors: 'numberOfProcessors',
  ramAmount: 'ramAmount',
  startDate: 'startDate',
  avgCPU: 'avgCPU',
  avgGPU: 'avgGPU',
  gpuModels: {
    name: 'gpuModels',
    fields: {
      model: 'model',
      number: 'number'
    }
  },
  lastUpdated: 'lastUpdated'
};